// import { AnimateProvider } from '@features/animations/components/animate-provider';
// import { AnimatedTranslateComponent } from '@features/animations/components/animated-translate-component';
// import { NAVBAR_ANIMATION_DURATION } from '@features/animations/constants/animations';

import { useNavbarConfig } from './hooks/use-navbar-config';

export function CenterComponent() {
  const { title } = useNavbarConfig();

  // return (
  //   <AnimateProvider>
  //     {!title ? null : (
  //       <AnimatedTranslateComponent
  //         key={`title-navbar-${title}`}
  //         duration={NAVBAR_ANIMATION_DURATION}
  //         x={4}
  //       >
  //         <div className="flex-grow">
  //           <span className="text-l-green-700 font-bold text-lg">{title}</span>
  //         </div>
  //       </AnimatedTranslateComponent>
  //     )}
  //   </AnimateProvider>
  // );

  return (
    <div className="flex-grow">
      <span className="text-l-green-700 font-bold text-lg">{title}</span>
    </div>
  );
}
